import Vue from 'vue';
import { init as SentryInit } from '@sentry/browser'
import { Vue as SentryVueIntegration } from '@sentry/integrations'

SentryInit({
    dsn: process.env.VUE_APP_SENTRY_ENDPOINT,
    integrations: [
        new SentryVueIntegration({ Vue, attachProps: true }),
    ],
});
